export const firebaseConfig = {
  apiKey: "AIzaSyAq29k0mWfGgOV-mrBYdaktd4TGe0FyraI",
  authDomain: "omnicure.firebaseapp.com",
  databaseURL: "https://omnicure.firebaseio.com",
  projectId: "omnicure",
  storageBucket: "omnicure.appspot.com",
  messagingSenderId: "493079331956",
  appId: "1:493079331956:web:0d29ed98e40c4b5c53fd21",
  measurementId: "G-CELWVQCHJ1",
  speechToTextURL:
    "https://streaming-speech-to-text-dot-omnicure.uc.r.appspot.com",
};
